module.exports = __webpack_public_path__ + "static/img/baac.df920259.svg";